import React, { useContext, useEffect } from "react";
import "../../styles/screens/screens.css";
import "../../styles/screens/general.scss";

import { Context } from "../../provider/index.js";
import languageData from "../../data/language.json";
import Cookies from "js-cookie";

const EndScreen = ({ type }) => {
  const { admin, dispatch } = useContext(Context);
  const currentLanguage = admin.language;
  const textData = languageData[currentLanguage];

  const m = Math.floor((admin.time / 60) % 60);
  const s = Math.floor(admin.time % 60);

  const seconds = s < 10 ? "0" + s : s;
  const minutes = m < 10 ? "0" + m : m;

  useEffect(() => {
    console.log(
      parseInt(admin.score),
      parseInt(admin.highScore),
      `${admin.score}`
    );

    if (parseInt(admin.score) > parseInt(admin.highScore)) {
      localStorage.setItem("highScore", `${admin.score}`);
      localStorage.setItem("highPlayer", `${admin.randomName}`);

      Cookies.set("highScore", `${admin.score}`, { expires: 2 });
      Cookies.set("highPlayer", `${admin.randomName}`, { expires: 2 });

      dispatch({ type: "highScore", payload: admin.score });
      dispatch({ type: "highPlayer", payload: admin.randomName });
    }
  }, [admin.score]);

  return (
    <div className="endPageCont" id="endPageCont">
      <div className="endContainer">
        <div className="levelTextContainer">
          <div className="scoreCont endscreen">
            <h2 className="scoreText levelup endscreen">
              {textData.explPage.level}{" "}
              {admin.level > 1
                ? admin.level - (type == "lose" ? 1 : 0)
                : admin.level}
            </h2>
            <h2 className="scoreNumber endscreen">
              {admin.highPlayer} {("000000" + admin.highScore).slice(-6)}
            </h2>
          </div>
          <div className="textWinContainer">
            <h3 className="winText">
              {type == "win"
                ? textData.endPageWin.message
                : textData.endPageLose.message}
              <div className="winningName">
                <nobr>{admin.randomName} !</nobr>
              </div>
            </h3>
            <img
              src={`./images/gifs/${type == "win" ? "win" : "game_over"}.gif`}
              className="endTitle endscreen"
              alt="you win!"
            ></img>
            <h3 className="endScore">
              {admin.level <= 4 ? (
                <span>
                  {type == "win"
                    ? textData.endPageWin.message2
                    : textData.endPageLose.message2}
                </span>
              ) : null}
              {admin.level >= 5 && (
                <h3
                  className="endPagePriceMessage"
                  dangerouslySetInnerHTML={{
                    __html: `<nobr>
                    ${
                      type === "win"
                        ? textData.endPageWin.priceMessageEnd
                        : textData.endPageLose.priceMessage
                    }
                    ${
                      type === "lose"
                        ? textData.endPageLose.priceLose[admin.level - 4]
                        : ""
                    }
                    ${type === "win" ? "" : textData.endPageLose.priceMessage2}
                  </nobr>`,
                  }}
                />
              )}
              <div className="endScoreText">
                <small>{textData.endPageWin.score}</small>
                <br /> {("000000" + admin.score).slice(-6)}
              </div>
            </h3>
          </div>
          <div className="scoreConBottom">
            <h2 className="timeText levelup endscreen">
              {textData.endPageWin.time}
            </h2>
            <h2 className="timeNumber endscreen">
              {minutes}:{seconds}
            </h2>
          </div>
        </div>
        <h3 className="footerText">
          {type == "win"
            ? textData.endPageWin.price
            : textData.endPageLose.price}
        </h3>
      </div>
    </div>
  );
};

export default EndScreen;
